export default __webpack_public_path__ + "static/media/cholet6.436e16f3.jpg";